<template>
    <div class="overflow-hidden absolute left-0.5 right-0.5 top-4 h-1 text-xs flex rounded-t-2xl bg-blue-200 opacity-100" v-if="showLoading">
        <div class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-500 animate-slider w-1/6 absolute h-full"></div>
    </div>
</template>
<script>
export default {
    props:['showLoading']
}
</script>